import React, { useEffect } from 'react';
import './embedded-signup-screen.scss';
import {
  useAppSelector,
  useEmbeddedSignupCallbackMutation,
} from '@zonofi/zono-money-store';
import { useSearchParams } from 'react-router-dom';
import { PNGS, SVGS } from '@zonofi/zono-money-design-system';
import { getConfigValue } from '@zonofi/common';
import { dispatch, updateUserId, getUserId } from '@zonofi/zono-money-store';
import {
  getAgentFlowProgress,
  updateAgentFlowProgress,
} from '@zonofi/zono-money-helpers';

export enum AbandonedFlowScreens {
  BUSINESS_ACCOUNT_SELECTION = 'BUSINESS_ACCOUNT_SELECTION',
  WABA_PHONE_PROFILE_PICKER = 'WABA_PHONE_PROFILE_PICKER',
  WHATSAPP_BUSINESS_PROFILE_SETUP = 'WHATSAPP_BUSINESS_PROFILE_SETUP',
  PHONE_NUMBER_SETUP = 'PHONE_NUMBER_SETUP',
  PHONE_NUMBER_VERIFICATION = 'PHONE_NUMBER_VERIFICATION',
  PERMISSIONS = 'PERMISSIONS',
}

export interface EmbeddedSignUpSuccessData {
  phone_number_id: string;
  waba_id: string;
}

export interface EmbeddedSignUpAbandonedData {
  current_step: AbandonedFlowScreens;
}

export interface EmbeddedSignUpErrorData {
  error_message: string;
}

export interface EmbeddedSignUpFinishDTO {
  event: 'FINISH';
  data: EmbeddedSignUpSuccessData;
  esLinkID: string;
}

export interface EmbeddedSignUpCancelDTO {
  event: 'CANCEL';
  data: EmbeddedSignUpAbandonedData;
  esLinkID: string;
}

export interface EmbeddedSignUpErrorDTO {
  event: 'ERROR';
  data: EmbeddedSignUpErrorData;
  esLinkID: string;
}

export type EmbeddedSignUpDTO =
  | EmbeddedSignUpFinishDTO
  | EmbeddedSignUpCancelDTO
  | EmbeddedSignUpErrorDTO;
export const EmbeddedSignupScreen: React.FC = () => {
  const userIdFromStore = useAppSelector(getUserId);
  const appURL = getConfigValue('LOGIN');
  const [isSuccess, setIsSuccess] = React.useState(false);
  const [facebookSDKLoaded, setFacebookSDKLoaded] =
    React.useState<boolean>(false);
  const [embeddedSignupCallback] = useEmbeddedSignupCallbackMutation();
  const [searchParams] = useSearchParams();
  const esLinkId = searchParams.get('esLinkId');
  const firmName = searchParams.get('firmName');
  const userId = searchParams.get('userId') || '';
  const sellerWorkspaceId = searchParams.get('sellerWorkspaceId');

  console.log('esLinkId', esLinkId);
  console.log('userId from embedded-signup-screen mobile-zotok', userId);

  useEffect(() => {
    console.log('isSuccess : ', isSuccess);
  }, [isSuccess]);

  useEffect(() => {
    // Facebook Pixel initialization
    /* eslint-disable */
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
      null,
      null,
      null
    );
    /* eslint-enable */
    if ((window as any).fbq) {
      (window as any).fbq('init', 'your-pixel-id-goes-here');
      (window as any).fbq('track', 'PageView');
    }

    (window as any).fbAsyncInit = function () {
      (window as any).FB.init({
        appId: '603092012610009',
        cookie: true,
        xfbml: true,
        version: 'v19.0',
      });

      setFacebookSDKLoaded(true);
      console.log('facebookSDKLoaded: ', facebookSDKLoaded);
    };

    (function (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      const js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');

    window.addEventListener('message', async (event) => {
      if (
        event.origin !== 'https://www.facebook.com' &&
        event.origin !== 'https://web.facebook.com'
      ) {
        console.log('event.origin: ', event);
        return;
      }
      try {
        console.log('event.data: ', event); // remove after testing
        const data = JSON.parse(event.data);
        console.log('message event: ', data); // remove after testing

        console.log('data.event : ', data.event);

        if (data.event === 'FINISH') {
          console.log('getting finish event');
          setIsSuccess(true);
        }
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          console.log('message event: ', data); // remove after testing
          const payload: any = {
            sellerWorkspaceId: sellerWorkspaceId,
            event: data.event,
            esLinkID: esLinkId,
            data: {},
          };
          if (data.event === 'START') {
            // No additional data needed for START
          } else if (data.event === 'CANCEL') {
            payload.data = {
              current_step:
                data.data.current_step ||
                AbandonedFlowScreens.BUSINESS_ACCOUNT_SELECTION,
            };
          } else if (data.event === 'ERROR') {
            payload.data = {
              error_message: data.data.error_message || 'Unknown error',
            };
          } else if (
            data.event === 'FINISH' ||
            data.event === 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING'
          ) {
            console.log(userIdFromStore, 'userIdFromStore');
            if (userId && userId?.length > 0) {
              console.log('userId : ', userId);
              await updateAgentFlowProgress(userId, 3);
            }
            if (data.data) {
              payload.data = {
                phone_number_id: data.data.phone_number_id,
                waba_id: data.data.waba_id,
              };
            }
          }
          // your code goes here
          embeddedSignupCallback(payload);
        }
      } catch {
        console.log('message event: ', event.data); // remove after testing
        // your code goes here
      }
    });

    return () => {
      // Clean up the event listener on component unmount
      window.removeEventListener('message', () => {});
    };
  }, []);

  useEffect(() => {
    if (userId && userId?.length > 0) {
      dispatch(updateUserId(userId));
    }
  }, [userId]);

  const launchWhatsAppSignup = () => {
    console.log(
      'launchWhatsAppSignup called : ',
      typeof (window as any).FB,
      facebookSDKLoaded
    );
    if (facebookSDKLoaded && typeof (window as any).FB !== 'undefined') {
      console.log('launchWhatsAppSignup');
      // Reset Facebook login state before attempting new login
      (window as any).FB.getLoginStatus(function (response: any) {
        if (response && response.status === 'connected') {
          (window as any).FB.logout(function () {
            console.log('Reset Facebook state before new login');
            performFacebookLogin();
          });
        } else {
          performFacebookLogin();
        }
      });
    } else {
      setTimeout(launchWhatsAppSignup, 100);
    }
  };

  const performFacebookLogin = () => {
    if ((window as any).fbq) {
      (window as any).fbq('trackCustom', 'WhatsAppOnboardingStart', {
        appId: '603092012610009',
        feature: 'whatsapp_embedded_signup',
      });
    }

    if ((window as any).FB) {
      (window as any).FB.login(
        function (response: any) {
          console.log(response, 'response ===========>');

          if (response.authResponse) {
            console.log(response, 'response');
          } else {
            embeddedSignupCallback({
              event: 'CANCEL',
              esLinkID: esLinkId,
              sellerWorkspaceId: sellerWorkspaceId,
              data: {
                current_step: AbandonedFlowScreens.BUSINESS_ACCOUNT_SELECTION,
              },
            } as any);
            // navigate(WABA_SETUP_ROUTES.WABA_SETUP_SUCCESS.path); // Commented out - missing import
            console.log('User cancelled login or did not fully authorize.');
          }
        },
        {
          config_id: '656976636768601',
          app_id: '603092012610009',
          response_type: 'code',
          override_default_response_type: true,

          extras: {
            featureType: 'whatsapp_business_app_onboarding',
            sessionInfoVersion: '3',
            setup: { solutionID: '973279847657464' },
          },
        }
      );
    }
  };

  useEffect(() => {
    if (userId) {
      getAgentFlowProgress(userId);
    }
  }, [userId]);

  return (
    <div
      className="embedded-signup-screen"
      style={{ fontFamily: 'Segoe-UI, sans-serif' }}
    >
      {/* Header */}
      <header className="header">
        <div className="header__content">
          <img
            src={SVGS.ZotokNewLogo}
            alt="Zotok Logo"
            className="header__logo"
          />
        </div>
      </header>

      {/* Main Content */}
      <div
        className="main-content"
        style={{
          backgroundImage: `url(${PNGS.ESBG1})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
          flexDirection: 'column',
          fontFamily: 'Segoe-UI, sans-serif',
        }}
      >
        <div
          className="card"
          style={{ position: 'relative', fontFamily: 'Segoe-UI, sans-serif' }}
        >
          {/* Gradient Strip */}
          <div
            style={{
              width: '100%',
              height: '8px',
              position: 'absolute',
              top: 0,
              left: 0,
              background:
                'linear-gradient(90deg, #8C3CFF -0.88%, #32A7E8 24.28%, #2ABB7F 49.35%, #0067FF 74.08%, #262626 99.16%)',
            }}
          ></div>

          {/* WhatsApp Logo */}
          <div className="card__logo-container">
            <div className="card__logo-wrapper">
              <div className="card__logo-wrapper-inner">
                <div className="card__logo">
                  <img
                    src={isSuccess ? SVGS.SuccessTick : PNGS.Whatsapp3D}
                    width={120}
                    height={120}
                    alt="WhatsApp Logo"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Title and Description */}
          <div
            className="card__title"
            style={{ fontFamily: 'Segoe-UI, sans-serif' }}
          >
            <h1 style={{ fontFamily: 'Segoe-UI, sans-serif' }}>
              {isSuccess
                ? 'WhatsApp account created successfully!'
                : 'WABA Sign-up launcher'}
            </h1>
            <p style={{ fontFamily: 'Segoe-UI, sans-serif' }}>
              {isSuccess
                ? `Now click on "Go to Zotok App" button to navigate back to 
complete the flow.`
                : 'The launcher will launch the Facebook business portal in a browser pop-up and will navigate you through the step by step flow. Click on the "Launch" button to start the flow.'}
            </p>
          </div>

          {/* Form */}
          <div
            className="card__form"
            style={{
              display: 'flex',
              justifyContent: 'center',
              fontFamily: 'Segoe-UI, sans-serif',
            }}
          >
            <div
              className="card__form-input"
              style={{
                display: 'inline-flex',
                width: 'auto',
                fontFamily: 'Segoe-UI, sans-serif',
              }}
            >
              <div className="card__form-input-prefix">
                <div className="card__form-input-prefix-initials">
                  {firmName?.slice(0, 2).toUpperCase()}
                </div>
              </div>
              <div
                className="card__form-input-content"
                style={{ fontFamily: 'Segoe-UI, sans-serif' }}
              >
                <div
                  className="card__form-input-content-label"
                  style={{ fontFamily: 'Segoe-UI, sans-serif' }}
                >
                  Firm Name
                </div>
                <input
                  type="text"
                  disabled
                  value={firmName}
                  onChange={() => {}}
                  placeholder="Enter your firm name"
                  style={{ fontFamily: 'Segoe-UI, sans-serif' }}
                />
              </div>
            </div>
          </div>

          {/* Button */}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <button
              onClick={() => {
                if (isSuccess) {
                  // Open URL in new tab instead of redirecting current page
                  console.log('opening url : ', appURL);
                  window.open(appURL, '_blank');
                } else {
                  console.log(
                    'opening url : calling embeddedSignupCallback...'
                  );
                  embeddedSignupCallback({
                    event: 'START',
                    esLinkID: esLinkId,
                    sellerWorkspaceId: sellerWorkspaceId,
                    data: {},
                  } as any);
                  launchWhatsAppSignup();
                }
              }}
              className="card__button"
              style={{
                width: 250,
                padding: '0.75rem 2rem',
                fontFamily: 'Segoe-UI, sans-serif',
              }}
            >
              {isSuccess ? 'Go to Zotok App' : 'Launch Embedded Sign up'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
